/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CancelSubscription/SubscriptionCancelled/theme';

export const CancelSubscriptionSubscriptionCancelledTheme = theme;
